/**
 * Cheap, deterministic OS detection. We only branch on iOS vs Android vs
 * "other" — that's enough to pick the right store URL. User-agent sniffing
 * is good enough here because we're choosing between two known stores, not
 * gating real features.
 */
export type OS = 'ios' | 'android' | 'other';

const STORE_URLS = {
  iosEn: 'https://apps.apple.com/app/id783330557',
  iosDe: 'https://itunes.apple.com/de/app/kommgutheim/id783330557',
  android: 'https://play.google.com/store/apps/details?id=com.arrivesafe',
} as const;

export function detectOS(): OS {
  if (typeof navigator === 'undefined') return 'other';
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
  // Modern iPads ship with a Macintosh UA — distinguish via touch points.
  if (/Macintosh/.test(ua) && (navigator as Navigator & { maxTouchPoints?: number }).maxTouchPoints && (navigator as Navigator & { maxTouchPoints: number }).maxTouchPoints > 1) {
    return 'ios';
  }
  if (/Android/i.test(ua)) return 'android';
  return 'other';
}

export function appStoreUrl(os: OS, locale: string = 'en'): string {
  if (os === 'ios') return locale === 'de' ? STORE_URLS.iosDe : STORE_URLS.iosEn;
  if (os === 'android') return STORE_URLS.android;
  // Fallback for desktop / other — prefer the iOS store as a generic landing.
  return STORE_URLS.iosEn;
}

export const APP_STORE_URLS = STORE_URLS;
